import request from "../../../utils/Request";
import {ATTEndpoints} from "../endpoints";
import qs from 'qs';


const list = async (params?: Record<string, any>) => {
  const response = await request.authorizedAxios().get(ATTEndpoints.ATT_TIMECARD_URI, {params, paramsSerializer: params => qs.stringify(params, {indices: false})});
  return response?.data;
}

const addLocation = async (data: any) => {
  const response = await request.authorizedAxios().post(ATTEndpoints.MOBILE_LOCATION_DETAIL, data)
  return response?.data;
};

const destroy = async (id: string) => {
  const response = await request.authorizedAxios().delete(`${ATTEndpoints.MOBILE_LOCATION_DETAIL}${id}/`);
  return response;
}

const update = async (id: string, data: any) => {
  const response = await request.authorizedAxios().put(`${ATTEndpoints.MOBILE_LOCATION_DETAIL}${id}/`, data);
  return response;
}

const retrieve = async (id: string) => {
  const response = await request.authorizedAxios().get(`${ATTEndpoints.MOBILE_LOCATION_DETAIL}${id}/`);
  return response;
}

const MobileService = {
  list,
  addLocation,
  destroy,
  update,
  retrieve,
}
export default MobileService;
